module.exports = __webpack_public_path__ + "img/Icon.90c5a80d.svg";